import ExtendableError from './ExtendableError'

/**
 * @class UnhandledError
 *
 * @description this error represents an error that should be handled
 */
class UnhandledError extends ExtendableError {
  /**
   *
   * @param message
   * @param payload
   * @param previous
   */
  constructor(message, payload = {}, previous = null) {
    super(message, payload, previous)
  }
}

export default UnhandledError
